module.exports = __webpack_public_path__ + "img/Eudoxus_Publisher_Logo_white_Gr.00e5d401.png";